// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"99c80f28","488":"82868655"}[chunkId] + ".chunk.js";
};